import { gql } from "@apollo/client";

export const METADATA_BASE_FIELD_FRAGMENT = gql`
  fragment MetadataBaseField on CampaignMetadataBaseField {
    __typename
    id
    name
    required
    archived
  }
`;

export const METADATA_BOOL_FIELD_FRAGMENT = gql`
  fragment MetadataBoolField on CampaignMetadataBoolField {
    ...MetadataBaseField
    defaultBoolValue: defaultValue
  }
  ${METADATA_BASE_FIELD_FRAGMENT}
`;

export const METADATA_STRING_FIELD_FRAGMENT = gql`
  fragment MetadataStringField on CampaignMetadataStringField {
    ...MetadataBaseField
    defaultStringValue: defaultValue
    configuration {
      maxLength
    }
  }
  ${METADATA_BASE_FIELD_FRAGMENT}
`;

export const METADATA_ENUM_MULTI_FIELD_FRAGMENT = gql`
  fragment MetadataEnumMultiField on CampaignMetadataEnumMultiField {
    ...MetadataBaseField
    defaultEnumMultiValue: defaultValue
    configuration {
      values
      archived
    }
  }
  ${METADATA_BASE_FIELD_FRAGMENT}
`;

export const METADATA_ENUM_FIELD_FRAGMENT = gql`
  fragment MetadataEnumField on CampaignMetadataEnumField {
    ...MetadataBaseField
    defaultEnumValue: defaultValue
    configuration {
      values
      archived
    }
  }
  ${METADATA_BASE_FIELD_FRAGMENT}
`;

export const METADATA_USER_LIST_FIELD_FRAGMENT = gql`
  fragment MetadataUserListField on CampaignMetadataUserListField {
    ...MetadataBaseField
  }
  ${METADATA_BASE_FIELD_FRAGMENT}
`;

export const METADATA_STATE_FIELD_FRAGMENT = gql`
  fragment MetadataStateField on CampaignMetadataStateField {
    ...MetadataBaseField
    defaultStateValue: defaultValue
    configuration {
      values
      archived
      isSingleSelect
    }
  }
  ${METADATA_BASE_FIELD_FRAGMENT}
`;

export const METADATA_FIELDS_FRAGMENT = gql`
  fragment MetadataFields on CampaignMetadataField {
    ... on CampaignMetadataBoolField {
      ...MetadataBoolField
    }
    ... on CampaignMetadataStringField {
      ...MetadataStringField
    }
    ... on CampaignMetadataEnumMultiField {
      ...MetadataEnumMultiField
    }
    ... on CampaignMetadataEnumField {
      ...MetadataEnumField
    }
    ... on CampaignMetadataUserListField {
      ...MetadataBaseField
    }
    ... on CampaignMetadataStateField {
      ...MetadataStateField
    }
  }

  ${METADATA_BOOL_FIELD_FRAGMENT}
  ${METADATA_STRING_FIELD_FRAGMENT}
  ${METADATA_ENUM_MULTI_FIELD_FRAGMENT}
  ${METADATA_ENUM_FIELD_FRAGMENT}
  ${METADATA_STATE_FIELD_FRAGMENT}
`;

export const GET_TENANT_METADATA_FIELDS = gql`
  query getCampaignMetadataFieldsForTenant {
    campaignMetadataFieldsForTenant {
      ...MetadataFields
    }
  }
  ${METADATA_FIELDS_FRAGMENT}
`;

export const UPDATE_METADATA_STRING_FIELD = gql`
  mutation UpdateMetadataStringField(
    $input: CreateOrUpdateCampaignMetadataStringFieldInput!
  ) {
    createOrUpdateCampaignMetadataStringField(input: $input) {
      __typename
      id
      name
      required
      archived
      defaultStringValue: defaultValue
      configuration {
        maxLength
      }
    }
  }
`;

export const ARCHIVE_METADATA_FIELD = gql`
  mutation ArchiveMetadataField($input: ArchiveCampaignMetadataFieldInput!) {
    archiveCampaignMetadataField(input: $input) {
      ...MetadataFields
    }
  }
  ${METADATA_FIELDS_FRAGMENT}
`;

export const UPDATE_METADATA_BOOL_FIELD = gql`
  mutation UpdateMetadataBoolField(
    $input: CreateOrUpdateCampaignMetadataBoolFieldInput!
  ) {
    createOrUpdateCampaignMetadataBoolField(input: $input) {
      __typename
      id
      name
      archived
      required
      defaultBoolValue: defaultValue
    }
  }
`;

export const UPDATE_METADATA_ENUM_FIELD = gql`
  mutation UpdateMetadataEnumField(
    $input: CreateOrUpdateCampaignMetadataEnumFieldInput!
  ) {
    createOrUpdateCampaignMetadataEnumField(input: $input) {
      __typename
      id
      name
      archived
      required
      defaultValueEnum: defaultValue
      configuration {
        values
        archived
      }
    }
  }
`;

export const UPDATE_METADATA_ENUM_MULTI_FIELD = gql`
  mutation UpdateMetadataEnumMultiField(
    $input: CreateOrUpdateCampaignMetadataEnumMultiFieldInput!
  ) {
    createOrUpdateCampaignMetadataEnumMultiField(input: $input) {
      ...MetadataEnumMultiField
    }
  }
  ${METADATA_ENUM_MULTI_FIELD_FRAGMENT}
`;

export const UPDATE_METADATA_USER_LIST_FIELD = gql`
  mutation UpdateMetadataUserListField(
    $input: CreateOrUpdateCampaignMetadataUserListFieldInput!
  ) {
    createOrUpdateCampaignMetadataUserListField(input: $input) {
      ...MetadataUserListField
    }
  }
  ${METADATA_USER_LIST_FIELD_FRAGMENT}
`;

export const UPDATE_METADATA_STATE_FIELD = gql`
  mutation UpdateMetadataStateField(
    $input: CreateOrUpdateCampaignMetadataStateFieldInput!
  ) {
    createOrUpdateCampaignMetadataStateField(input: $input) {
      ...MetadataStateField
    }
  }
  ${METADATA_STATE_FIELD_FRAGMENT}
`;

export const REACTIVATE_METADATA_FIELD = gql`
  mutation ReactivateMetadataField(
    $input: ReactivateCampaignMetadataFieldInput!
  ) {
    reactivateCampaignMetadataField(input: $input) {
      ...MetadataFields
    }
  }
  ${METADATA_FIELDS_FRAGMENT}
`;
